<template>
  <v-col cols="12" sm="12">
    <v-col cols="6" sm="6">
      <v-toolbar-title>Ordenes de Trabajo</v-toolbar-title>
      <br />
      <v-text-field
        v-model="buscar"
        :append-icon="'mdi-select-search'"
        label="Buscar OT por ID"
        dense
      ></v-text-field>
    </v-col>

    <!-- <v-tabs v-model="selectedTab" fixed-tabs background-color="indigo" dark>
      <v-tab
        v-for="(tipoOT, index) in listadotiposOT"
        :key="index"
        @click="cambiarTab(index)"
        @change="cambiarTab(index)"
      >
        {{ tipo }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="tipoOT in listadotiposOT" :key="tipoOT">
        <v-card color="white" flat>
          <v-card-text>{{ tipoOT.nombre }}</v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items> -->

    <v-tabs v-model="tab" color="white" background-color="indigo" dark>
      <v-tab
        v-for="(tab, index) in tabs"
        :key="index"
        @click="cambiarTab(index)"
        @change="cambiarTab(index)"
      >
        {{ tab }}
      </v-tab>
    </v-tabs>

    <template v-if="tab == 0">
      <v-data-table
        :headers="headers"
        :items="listaOT"
        item-key="idOT"
        sort-by="idOT"
        :search="buscar"
        :header-props="headerProps"
        :footer-props="$store.state.traduccionTabla"
        no-data-text="No se encontraron registros"
        no-results-text="No se encontraron registros en la búsqueda"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip left color="blue">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="blue"
                dark
                class="mx-2"
                @click="verMaterialesOT(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-eye </v-icon>
              </v-btn>
            </template>
            <span>Ver Materiales</span>
          </v-tooltip>
          <!-- <template v-if="item.contratista == null">
          <v-tooltip left color="green">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="green"
                dark
                class="mx-2"
                @click="asignarOTContratista(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-account-multiple-plus-outline </v-icon>
              </v-btn>
            </template>
            <span>Asignar OT</span>
          </v-tooltip>
        </template> -->
          <v-tooltip left color="red">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="red"
                dark
                class="mx-2"
                @click="cerrarOTContratista(item)"
                v-bind="attrs"
                v-on="on"
                v-if="contratistaAsignado(item) == false"
              >
                <v-icon dark> mdi-close-circle </v-icon>
              </v-btn>
            </template>
            <span>Cerrar OT</span>
          </v-tooltip>

          <v-tooltip left color="green">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="green"
                dark
                class="mx-2"
                @click="asignarOTContratista(item)"
                v-bind="attrs"
                v-on="on"
                v-if="contratistaAsignado(item) == true"
              >
                <v-icon dark> mdi-account-multiple-plus-outline </v-icon>
              </v-btn>
            </template>
            <span>Asignar OT</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>

    <template v-if="tab == 1">
      <v-data-table
        :headers="headersCerradas"
        :items="listaOTCerradas"
        item-key="idOT"
        sort-by="idOT"
        :search="buscar"
        :footer-props="$store.state.traduccionTabla"
        no-data-text="No se encontraron registros"
        no-results-text="No se encontraron registros en la búsqueda"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip left color="blue">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="blue"
                dark
                class="mx-2"
                @click="verMaterialesOT(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-eye </v-icon>
              </v-btn>
            </template>
            <span>Ver Materiales</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>

    <!-- <dialogOT ref="dialogOT" @resultado="confirmarOperacion" /> -->
    <dialogOT ref="dialogOT" @recargarListado="recargarListado" />

    <dialogMensaje ref="dialogMensaje" @resultado="confirmarOperacion" />
  </v-col>
</template>
<script>
import dialogOT from "@/modulos/OT/componentes/modalOT.vue";
import dialogMensaje from "@/components/modalMensaje.vue";
import axios from "axios";
export default {
  components: {
    dialogOT,
    dialogMensaje,
  },
  data: () => ({
    tab: null,
    tabs: ["Abiertas", "Cerradas"],
    listadotiposOT: [{ nombre: "Abiertas" }, { nombre: "Cerradas" }],
    idOT: "",
    tipoOperacion: "",
    espacioEnBlanco: "",
    listaOT: [],
    idOTTitulo: "",
    dialogDelete: false,
    headers: [
      { text: "ID OT", value: "ord_ot", class: "black white--text" },
      { text: "Descripcion", value: "descripcion", class: "black white--text" },
      {
        text: "Contratista",
        value: "contratistaDescripcion",
        class: "black white--text",
      },
      { text: "Acciones", value: "actions", class: "black white--text" },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },

    headersCerradas: [
      { text: "ID OT", value: "ord_ot", class: "black white--text" },
      //{ text: "Descripcion", value: "descripcion", class: "black white--text" },
      {
        text: "Contratista",
        value: "contratistaDescripcion",
        class: "black white--text",
      },
      { text: "Acciones", value: "actions", class: "black white--text" },
    ],
    other: [1, 20, 344, 44444],
    footerProps: {
      itemsPerPageText: "Registros por página",
      pageText: "{0}-{1} de {2}",
      itemsPerPageOptions: [5, 10, 20, 50, 100, { text: "Todos", value: -1 }],
    },
    buscar: "",
    Materiales: [],
    editedIndex: -1,
    editedItem: {
      idMaterial: "",
      descripcion: 0,
    },
    defaultItem: {
      idMaterial: "",
      descripcion: 0,
    },
  }),

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  mounted() {
    //this.getListarMaterialesContratista();
    //this.getRecuperarServicios();
    this.getListarOT();
    this.recuperarOTCerradas();
  },
  methods: {
    async recuperarOTCerradas() {
      this.url =
        this.$store.getters.urlBase +
        "OT/recuperarOTsCerradas?idDistrito=" +
        this.$store.getters.usuario.idDistrito;
      console.log("La es:");
      console.log(this.url);

      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("La respuesta es: ");
          console.log(response);
          this.listaOTCerradas = response.data;
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      this.loadingButton = false;
      //this.dialog = false;
      //this.listaOTCerradas = respuesta;

      console.log("EL mensaje de la operacion");
      console.log(respuesta);
      console.log(this.listaOTCerradas);
    },

    cambiarTab(index) {
      if (index == 0) {
        this.getListarOT();
      } else {
        this.recuperarOTCerradas();
      }
    },

    async confirmarOperacion(resultadoFinal) {
      console.log("El resultado de la operacion es: ");
      console.log(resultadoFinal);
      if (resultadoFinal == true) {
        if (this.tipoOperacion == 3) {
          this.url = this.$store.getters.urlBase + "OT/cerrarOT";

          console.log("La idOT es");
          console.log(this.url);

          var obj = {
            idOT: this.idOT,
            idUsuario: this.$store.getters.usuario.user_id,
          };

          var respuesta = await axios
            .post(this.url, obj)
            .then((response) => {
              console.log("La respuesta es: ");
              console.log(response);
              return response;
              //this.tablaMaterialesCajonModificacion = response.data;
            })
            .catch((error) => {
              console.log(error.response);
              if (error.response == undefined) {
                this.mensajeSnack = "Error de Conexion";
              } else {
                if (error.response.status === 401) {
                  this.mensajeSnack =
                    "No posee autorizacion para ver esta informacion";
                } else {
                  if (error.response.data != "") {
                    this.mensajeSnack = error.response.data;
                  }
                }
              }
              this.loadingButton = false;
              this.colorSnack = "red";
              this.Showsnackbar = true;
            });

          this.loadingButton = false;
          this.dialog = false;

          console.log("EL mensaje de la operacion");
          console.log(respuesta.data);
          if (respuesta.data.includes("Operacion Exitosa")) {
            console.log("Operacion Exitosa");
            this.$refs.dialogMensaje.abrirMensajeDialog(
              respuesta.data,
              1,
              "green",
              "Confirmacion"
            );
          } else {
            console.log("Operacion FAllida");
            this.$refs.dialogMensaje.abrirMensajeDialog(
              respuesta.data,
              1,
              "red",
              "Confirmacion"
            );
          }
        }
      }
    },
    // contratistaAsignado(item) {
    //   // console.log("El registro es: ");
    //   // console.log(item);
    //   if (
    //     item.contratistaDescripcion == "" ||
    //     item.contratistaDescripcion == null
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },

    contratistaAsignado(item) {
      console.log("Estado del contratista:", item.contratistaDescripcion);
      return (
        item.contratistaDescripcion == null ||
        item.contratistaDescripcion === ""
      );
    },

    recargarListado() {
      console.log("Ingreso en recargar Listado");
      this.getListarOT();
    },

    cerrarOTContratista(otSeleccionada) {
      //console.log("Ingreso en cerrar ot contratista");
      this.tipoOperacion = 3;
      this.$refs.dialogMensaje.abrirMensajeDialog(
        "Desea eliminar la OT " + otSeleccionada.ord_ot + "?",
        2,
        "red",
        "Confirmacion"
      );

      this.idOT = otSeleccionada.ord_ot;
      //this.$refs.dialogMensaje.cerrarOTModal(otSeleccionada);
    },

    asignarOTContratista(otSeleccionada) {
      console.log("Ingreso en asignar ot contratista");
      const listaContratista = this.listaOT.map((ot) => ot.idContratista);
      console.log("La lista de contratistas es: ");
      console.log(listaContratista);
      this.$refs.dialogOT.asignarOTContratista(
        otSeleccionada,
        listaContratista
      );
    },

    // asignarOTContratista(otSeleccionada) {
    //   console.log("INgreso en asignar ot contratista");
    //   const index = this.listaOT.findIndex(
    //     (ot) => ot.idOT === otSeleccionada.idOT
    //   );
    //   if (index !== -1) {
    //     this.$set(
    //       this.listaOT[index],
    //       "contratistaDescripcion",
    //       "Nuevo Contratista"
    //     );
    //   }
    // },

    async verMaterialesOT(otSeleccionada) {
      //   this.url =
      //     this.$store.state.urlBase +
      //     "Material/recuperarMaterialesXOT?idOT=" +
      //     otSeleccionada.ord_ot;
      //   //this.url = this.$store.getters.urlBase + "Gang";
      //   const options = {
      //     method: "GET",
      //     headers: {
      //       "content-type": "application/json",
      //     },
      //     url: this.url,
      //   };
      //   var respuesta = await axios(this.url, options);
      //   if (respuesta.status === 200) {
      //     console.log("la lista de Material es:");
      //     console.log(respuesta.data);
      //     this.listaOT = respuesta.data;
      //   } else {
      //     console.log("Error");
      //   }
      this.$refs.dialogOT.abrirModalMaterialesOT(otSeleccionada);
    },

    async getListarOT() {
      this.url =
        this.$store.state.urlBase +
        "OT/recuperarOTsOperador?idDistrito=" +
        this.$store.getters.usuario.idDistrito;
      //this.url = this.$store.getters.urlBase + "Gang";
      console.log(this.url);
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de OTs es:");
        console.log(respuesta.data);
        this.listaOT = respuesta.data;
      } else {
        console.log("Error");
      }
    },

    abrirAsignarTareas(datos) {
      this.$router.push({
        name: "Asignar Tarea a Material",
        params: { datos },
      });
    },
    AbrirModal() {
      // console.log(tipo)
      this.$router.push({
        name: "ArmarCajon",
        params: {
          datos: this.Materiales,
        },
      });
      //this.$refs.abrirModalInsert_Update.openModal(tipo);
    },
    AbrirModalModificacion(item) {
      this.$refs.abrirModalInsert_Update.openModalModificacion(item);
    },
    deleteItem(item) {
      this.editedIndex = this.Materiales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.Materiales.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async getListarMaterial() {
      this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Material es:");
        console.log(respuesta.data);
        this.Materiales = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getRecuperarServicios() {
      this.url = this.$store.getters.urlBase + "Gang/servicios";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("Los servicios son");
        console.log(respuesta.data);
        //this.Materiales = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },
  },
};
</script>
